import type { RecordingReport } from './apiErrorCode';

/**
 * Замер записи, пришедший с сервера, — обратно в блок задания (12.09.2026).
 *
 * 🔴 ЗАЧЕМ ОТДЕЛЬНЫЙ КАНАЛ, А НЕ ОЧЕРЕДЬ. Голосовой ответ уходит через
 * `lib/outbox.ts`, и та отдаёт вызывающему только «доставлено / не доставлено».
 * Доставка при этом часто случается ПОЗЖЕ — в фоновом проходе, когда вернулась
 * связь или приложение перезапустили, а `enqueue` давно вернул `false`. Провести
 * ответ сервера через очередь значило бы поменять её устройство ради одного вида
 * действия и всё равно не покрыть позднюю доставку.
 *
 * 🔴 РАДИ ЧЕГО. В проигрывателе длина обязана быть ПО ФАЙЛУ (`server_seconds`),
 * а не по часам страницы: ученица 11.09.2026 видела 2:30 у записи на 20 секунд
 * и отправила её, ничего не заподозрив (договор `record-integrity.md` §2.3 п. 3).
 *
 * ⚠️ СНИМОК ОБЯЗАН БЫТЬ УСТОЙЧИВЫМ. Блок читает его через `useSyncExternalStore`,
 * а тот сравнивает по ссылке: отдавая каждый раз новый объект, мы получили бы
 * бесконечную перерисовку страницы урока. Поэтому объект лежит в `Map` как есть.
 */

const byBlock = new Map<string, RecordingReport>();
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

/**
 * Сервер принял ответ и сказал, сколько в файле звука.
 *
 * Замера нет (старый сервер, ответ без записи, кривое число) — не запоминаем
 * ничего: пусть блок покажет честные часы, а не выдуманный ноль.
 */
export function publishRecordingDone(blockId: string, recording?: RecordingReport): void {
  if (!recording || typeof recording.server_seconds !== 'number' || !Number.isFinite(recording.server_seconds)) {
    return;
  }
  byBlock.set(blockId, recording);
  emit();
}

/** Ученик перезаписывает ответ — прежний замер к новой записи не относится. */
export function forgetRecordingResult(blockId: string): void {
  if (byBlock.delete(blockId)) emit();
}

export function recordingResultOf(blockId: string): RecordingReport | undefined {
  return byBlock.get(blockId);
}

export function subscribeRecordingResult(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Только для проверок. */
export function resetRecordingResults(): void {
  byBlock.clear();
  listeners.clear();
}
